import { useMemo } from 'react';

import pick from 'lodash/pick';

import { useGroupFilterParams } from '@pkg/hooks';

import { type GroupItemsFilterQuery } from '@app/client/common/structs/groups/groups';

const FILTERCOUNTKEYS: ReadonlyArray<keyof GroupItemsFilterQuery> = ['ownership', 'contract_addresses', 'members'];
/**
 * React Hook to return the count of filters enabled from useGroupFilterParams.
 * This is limited via FILTERCOUNTKEYS as there are default filters not shown to the user or in the URL.
 */
export const useGroupFilterCount = (): number => {
    const filters = useGroupFilterParams();
    return useMemo(() => {
        return filters ? Object.keys(pick(filters, FILTERCOUNTKEYS)).length : 0;
    }, [filters]);
};
